import { Component, HostBinding } from '@angular/core';
import { MatomoTracker } from 'ngx-matomo-client';
import { ChatbotService } from 'src/app/core/services/chatbot.service';
import { CookieService } from 'src/app/core/services/cookie.service';

@Component({
  selector: 'vee-cookie-banner',
  templateUrl: './cookie-banner.component.html',
  styleUrls: ['./cookie-banner.component.scss'],
  standalone: false
})
export class CookieBannerComponent {
  @HostBinding('class.max') open = false;
  public preferences = false;
  public searchfilter = false;
  public dataconsent = false;
  public google_analytics = false;
  public data_protection = false;
  constructor(
    public cookieService: CookieService, 
    private readonly tracker: MatomoTracker,
    private readonly chatbotService: ChatbotService
  ) {
    this.syncFromStoredRights();
  }

  openPreferences(): void {
    this.open = true;
    this.syncFromStoredRights();
  }

  private syncFromStoredRights(): void {
    const r = this.cookieService.rights;
    if (!r) return;
    this.preferences = r.save_preferences ?? false;
    this.searchfilter = r.save_filters ?? false;
    this.dataconsent = r.data_consent ?? false;
    this.google_analytics = r.google_analytics ?? false;
    this.data_protection = r.data_protection ?? false;
  }

  accept() {
    this.cookieService.rights = {
      save_preferences: this.preferences,
      save_filters: this.searchfilter,
      data_consent: this.dataconsent,
      google_analytics: this.google_analytics,
      data_protection: this.data_protection,
    };
    this.cookieService.neededRightsChange = undefined;
    
    // Set temporary state to close banner immediately
    this.cookieService.setJustConfirmed(true);
    
    if (this.dataconsent) {
      this.tracker.rememberConsentGiven();
      this.tracker.trackPageView();
    }
    if (this.google_analytics) {
      this.cookieService.loadGoogleTagManager();
    }
    if (this.data_protection) {
      this.chatbotService.loadChatbot();
    } else {
      this.chatbotService.unloadChatbot();
    }
  }

  get savePreferencesNeeded() {
    return this.cookieService.neededRightsChange?.save_preferences;
  }

  acceptAll() {
    this.cookieService.rights = {
      save_preferences: true,
      save_filters: true,
      data_consent: true,
      google_analytics: true,
      data_protection: true
    };
    this.cookieService.neededRightsChange = undefined;
    
    // Set temporary state to close banner immediately
    this.cookieService.setJustConfirmed(true);
    
    this.tracker.rememberConsentGiven();
    this.tracker.trackPageView();
    this.cookieService.loadGoogleTagManager();
    this.chatbotService.loadChatbot();
  }
}
